<div>
  <app-generic-form title="Recupero Password">
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" form-content>
      <p class="text-muted small mb-3">
        Inserisci il tuo indirizzo email. Ti invieremo un link per reimpostare la password.
      </p>

      @if (successMessage()) {
        <div class="alert alert-success" role="alert">
          {{ successMessage() }}
        </div>
      }

      @if (errorMessage()) {
        <div class="alert alert-danger" role="alert">
          {{ errorMessage() }}
        </div>
      }

      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input
          id="email"
          type="email"
          formControlName="email"
          class="form-control"
          [class.is-invalid]="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched"
          placeholder="Inserisci la tua email">
        @if (forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched) {
          <div class="invalid-feedback">
            Inserisci un indirizzo email valido.
          </div>
        }
      </div>

      <button
        type="submit"
        [disabled]="isLoading() || forgotPasswordForm.invalid"
        class="btn btn-primary w-100 mt-3 d-inline-flex align-items-center justify-content-center"
        id="forgotPasswordFormBtn">
        <i class="bi" [class.bi-hourglass-split]="isLoading()" [class.bi-envelope-at]="!isLoading()" aria-hidden="true"></i>
        <span class="ms-1">{{ isLoading() ? 'Invio in corso...' : 'Invia link di reset' }}</span>
      </button>

      <button
        class="btn btn-outline-secondary btn-sm w-100 mt-2 d-inline-flex align-items-center justify-content-center"
        type="button"
        id="backToLoginBtn"
        routerLink="/login">
        <i class="bi bi-arrow-left me-1" aria-hidden="true"></i>Torna al Login
      </button>
    </form>
  </app-generic-form>
</div>
